import useCustomFields from "@/composables/useCustomFields";
import { orderColumns } from "@/store/orders.store";
import { CustomColumn, CustomColumnEntity } from "@/types";
import { customFieldColumnKey } from "@/utils/customFieldFilters";
import { computed } from "vue";

const CUSTOM_FIELD_ENTITIES: CustomColumnEntity[] = ["Order", "OrderItem"];

export { customFieldColumnKey };

export function useAllColumns() {
  const { customFields } = useCustomFields();

  const allColumns = computed<CustomColumn[]>(() => {
    const customFieldColumns: CustomColumn[] =
      customFields?.value
        ?.filter((field) => field.id != null && !field.isInternal && CUSTOM_FIELD_ENTITIES.includes(field.entity as CustomColumnEntity))
        .map((field) => {
          const key = customFieldColumnKey(field);
          return {
            header: field.label,
            field: key,
            filterField: key,
            frozen: false,
            sortable: true,
            filter: true,
            showFilterMenu: true,
            type: "custom",
            entity: field.entity as CustomColumnEntity,
            customFieldId: field.id,
            fieldType: field.fieldType,
            options: field.options,
          };
        }) ?? [];

    return orderColumns.concat(customFieldColumns);
  });

  return { allColumns };
}
